var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.001 10.334C46.4408 10.3341 51.667 15.5611 51.667 22.001V30.667H54.001C56.5674 30.6672 58.667 32.7674 58.667 35.334V58.667C58.667 61.2335 56.5674 63.3338 54.001 63.334H26.001C23.4343 63.334 21.334 61.2336 21.334 58.667V35.334C21.334 32.7673 23.4343 30.667 26.001 30.667H47.2344V22.001C47.2344 18.0111 43.9908 14.7677 40.001 14.7676C36.011 14.7676 32.7676 18.011 32.7676 22.001V22.6172C32.7676 23.8414 31.7749 24.8339 30.5508 24.834C29.3266 24.834 28.334 23.8414 28.334 22.6172V22.001C28.334 15.561 33.561 10.334 40.001 10.334ZM48.8984 40.5703C48.109 39.7981 46.8428 39.8123 46.0703 40.6016L37.666 49.1895L34.3809 46.0537C33.5819 45.2911 32.3164 45.3204 31.5537 46.1191C30.7911 46.9181 30.8203 48.1836 31.6191 48.9463L36.333 53.4463C37.125 54.202 38.3779 54.1809 39.1436 53.3984L48.9297 43.3984C49.7018 42.609 49.6875 41.3428 48.8984 40.5703Z",
    fill: "#5FB71B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockCheck);
export default __webpack_public_path__ + "static/media/lock-check.19b6895ceaaf97b6d1b84e75b2246f40.svg";
export { ForwardRef as ReactComponent };